<template>
    <small-dialog
        v-model="dialog"
        @ok="create"
        title="Tambah link pendaftaran"
        loading="createRegistrationLink"
        scrollable
    >
        <template #activator="{ on }">
            <div class="text-right">
                <v-btn
                    v-on="on"
                    color="primary"
                    rounded
                >
                    Buat baru
                </v-btn>
            </div>
        </template>

        <registration-link-form
            v-model="registrationLink"
            ref="form"
        ></registration-link-form>
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog'
import RegistrationLinkForm from './RegistrationLinkForm.vue'

export default {
    components: {
        SmallDialog,
        RegistrationLinkForm,
    },

    data: () => ({
        dialog: false,
        registrationLink: {},
    }),

    methods: {
        async create() {
            await this.$apiv2.post('registration-link', {
                ...this.registrationLink,
                validUntil: this.registrationLink.validUntil
                    ? this.registrationLink.validUntil
                    : null,
            })

            this.dialog = false
            this.$refs.form.reset()
            this.$emit('create')
        },
    },
}
</script>
